
import { Component, Vue, Prop } from "vue-property-decorator";
import { ImagePreview, Toast } from "vant";
import { del } from "vue";

@Component({ name: "ImageViewer" })
export default class ImageViewer extends Vue {
    @Prop({ type: String, required: true })
    imageUrl!: string;

    scale = 1;
    translateX = 0;
    translateY = 0;
    isScaled = false;
    startDistance = 0;
    lastScale = 1;
    startX = 0;
    startY = 0;
    lastTranslateX = 0;
    lastTranslateY = 0;
    isPinchZooming = false;

    rotation = 0;
    startRotation = 0;
    lastRotation = 0;


    handleTouchStart(event: TouchEvent) {
        if (event.touches.length === 2) {
            this.isPinchZooming = true;
            const touch1 = event.touches[0];
            const touch2 = event.touches[1];
            this.startDistance = Math.hypot(
                touch2.clientX - touch1.clientX,
                touch2.clientY - touch1.clientY
            );
            this.lastScale = this.scale;
            this.startRotation = Math.atan2(touch2.clientY - touch1.clientY, touch2.clientX - touch1.clientX) * (180 / Math.PI);
            this.lastRotation = this.rotation;
        } else if (event.touches.length === 1 && this.scale > 1) {
            this.isPinchZooming = false;
            const touch = event.touches[0];
            this.startX = touch.clientX;
            this.startY = touch.clientY;
            this.lastTranslateX = this.translateX;
            this.lastTranslateY = this.translateY;
        }
    }

    handleTouchMove(event: TouchEvent) {

        const target = event.target as HTMLElement;
        var img: HTMLImageElement;
        if (target.tagName == "IMG") img = target as HTMLImageElement;
        else img = target.querySelector("img") as HTMLImageElement
        if (!img) {
            Toast({ message: `handleTouchEnd:img not found` })
            return;
        }

        if (event.touches.length === 2) {
            this.isPinchZooming = true;
            event.preventDefault();
            const touch1 = event.touches[0];
            const touch2 = event.touches[1];
            const currentDistance = Math.hypot(
                touch2.clientX - touch1.clientX,
                touch2.clientY - touch1.clientY
            );
            this.scale = this.lastScale * (currentDistance / this.startDistance);
            this.isScaled = this.scale !== 1;
            const currentRotation = Math.atan2(
                touch2.clientY - touch1.clientY,
                touch2.clientX - touch1.clientX
            ) * (180 / Math.PI);
            const deltaRotation = currentRotation - this.startRotation;
            this.rotation = (this.lastRotation + deltaRotation + 360) % 360;
        } else if (event.touches.length === 1) {
            if (this.isPinchZooming && this.scale > 1) {
                this.isPinchZooming = false;
                const touch = event.touches[0];
                this.startX = touch.clientX;
                this.startY = touch.clientY;
                this.lastTranslateX = this.translateX;
                this.lastTranslateY = this.translateY;
            }
            if (this.scale > 1) {
                event.preventDefault();
                const touch = event.touches[0];
                const deltaX = touch.clientX - this.startX;
                const deltaY = touch.clientY - this.startY;
                const scaledDeltaX = deltaX / this.scale;
                const scaledDeltaY = deltaY / this.scale;
                let newTranslateX = this.lastTranslateX + scaledDeltaX;
                let newTranslateY = this.lastTranslateY + scaledDeltaY;
                this.translateX = newTranslateX;
                this.translateY = newTranslateY;
                this.startX = touch.clientX;
                this.startY = touch.clientY;
                this.lastTranslateX = newTranslateX;
                this.lastTranslateY = newTranslateY;
            }
        }
        this.stopEvent(event)
    }

    handleTouchEnd(event: TouchEvent) {
        this.stopEvent(event)
        const target = event.target as HTMLElement;
        var img: HTMLImageElement;
        if (target.tagName == "IMG") img = target as HTMLImageElement;
        else img = target.querySelector("img") as HTMLImageElement
        if (!img) {
            Toast({ message: `handleTouchEnd:img not found` })
            return;
        }

        this.isPinchZooming = false;
        if (this.scale < 1) {
            this.scale = 1;
            this.translateX = 0;
            this.translateY = 0;
            this.isScaled = false;
            return;
        }

        const container = img.parentElement as HTMLElement;
        var rect = img.getBoundingClientRect();
        const containerWidth = container.clientWidth;
        const containerHeight = container.clientHeight;
        const maxTranslateX = Math.max(0, (rect.width - containerWidth) / this.scale / 2);
        const minTranslateX = Math.min(0, -maxTranslateX);
        const maxTranslateY = Math.max(0, (rect.height - containerHeight) / this.scale / 2);
        const minTranslateY = Math.min(0, -maxTranslateY);
        this.translateX = Math.min(Math.max(this.translateX, minTranslateX), maxTranslateX);
        this.translateY = Math.min(Math.max(this.translateY, minTranslateY), maxTranslateY);


    }

    handleDoubleClick(event: MouseEvent) {
        // this.stopEvent(event)

        if (this.scale === 1) {
            this.scale = 2;
            this.isScaled = true;
            this.translateX = 0;
            this.translateY = 0;
        } else {
            this.scale = 1;
            this.translateX = 0;
            this.translateY = 0;
            this.isScaled = false;
        }
    }
    stopEvent(event: Event) {
        if (this.isScaled) event.stopPropagation();
    }

    imgClick() {
        if (this.isScaled) return;
        this.$emit("fullView", this.imageUrl)
    }

}
